import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FileDown } from 'lucide-react-native';
import { memo, useState } from 'react';
import {
  ActivityIndicator,
  FlatList,
  RefreshControl,
  View,
} from 'react-native';
import {
  BiPageHeader,
  kBiContentMaxWidth,
} from '../components/ui/BiPageHeader';
import { BiRetry } from '../components/ui/BiRetry';
import { ExportRow } from './ExportRow';
import { useBiExports } from './useBiExports';

/** 导出记录: the member's PDF exports, newest first, to download. */
export const BiExportListView = memo(({ onBack }: { onBack: () => void }) => {
  const { rpx } = useResponsiveContext();
  const { state, reload, loadMore, downloadUrl } = useBiExports();
  const [refreshing, setRefreshing] = useState(false);
  const refresh = async () => {
    setRefreshing(true);
    await reload();
    setRefreshing(false);
  };
  const centered = (child: React.ReactNode) => (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: rpx(10),
        padding: rpx(24),
      }}
    >
      {child}
    </View>
  );
  return (
    <View style={{ flex: 1, backgroundColor: aiColors.background }}>
      <BiPageHeader title="导出记录" onBack={onBack} />
      {state.kind === 'loading' ? (
        centered(<ActivityIndicator />)
      ) : state.kind === 'failed' ? (
        centered(
          <>
            <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
              {state.message}
            </Typography.Text>
            <BiRetry label="重新加载" onRetry={() => void reload()} />
          </>,
        )
      ) : (
        <FlatList
          data={state.items}
          keyExtractor={item => item.id}
          renderItem={({ item }) => (
            <ExportRow item={item} downloadUrl={downloadUrl} />
          )}
          contentContainerStyle={{
            flexGrow: 1,
            padding: rpx(16),
            gap: rpx(12),
            width: '100%',
            maxWidth: kBiContentMaxWidth,
            alignSelf: 'center',
          }}
          refreshControl={
            <RefreshControl
              refreshing={refreshing}
              onRefresh={() => void refresh()}
            />
          }
          onEndReached={() => void loadMore()}
          onEndReachedThreshold={0.4}
          ListEmptyComponent={centered(
            <>
              <FileDown size={28} color={aiColors.mutedForeground} />
              <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
                还没有导出过看板。在看板的「导出 PDF」中导出。
              </Typography.Text>
            </>,
          )}
          ListFooterComponent={state.loadingMore ? <ActivityIndicator /> : null}
        />
      )}
    </View>
  );
});
